module.exports = __webpack_public_path__ + "img/wild_full.ceeb616d.png";